'use client'

import { TErrorPageProps } from '@ftd/types'
import { Button, Group, Stack, Title } from '@mantine/core'
import { getTranslations } from 'next-intl/server'
import { useEffect } from 'react'

import { Typography } from '@/components/atoms/Typography'
import { PageTemplate } from '@/components/templates/PageTemplate'
import { usePathname } from '@/i18n/routing'
import { log } from '@/lib'

export async function generateMetadata() {
  const t = await getTranslations('metadata')

  return {
    title: t('main_title'),
    description: t('error_description'),
  }
}

const Error: React.FC<TErrorPageProps> = ({ error }) => {
  const currentPath = usePathname()
  useEffect(() => log.error(error), [error])

  return (
    <PageTemplate bg="white" size="md">
      <Stack>
        <Title order={1}>Something went wrong</Title>
        <Typography>There was an error in loading this page. Please try again later.</Typography>

        <Group gap={5} mt="xl">
          <Button component="a" href={currentPath}>
            Reload
          </Button>
        </Group>
      </Stack>
    </PageTemplate>
  )
}

export default Error
